import { render, staticRenderFns } from "./TaskModuleRulesRuleEnabled.vue?vue&type=template&id=99f630d6&scoped=true"
import script from "./TaskModuleRulesRuleEnabled.vue?vue&type=script&lang=js"
export * from "./TaskModuleRulesRuleEnabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f630d6",
  null
  
)

export default component.exports